module.exports = __webpack_public_path__ + "static/media/60.e80d980f.png";